import { useEffect, useState } from "react";
import {
  fetchAgroecologyResourceLinks,
  AgroecologyResourceLink,
} from "../api/contentful";

export function useAgroecologyResourceLinks() {
  const [data, setData] = useState<AgroecologyResourceLink[] | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    fetchAgroecologyResourceLinks()
      .then((res) => setData(res))
      .catch(
        (err) =>
          setError(err.message || "Failed to load agroecology resource links"),
      )
      .finally(() => setLoading(false));
  }, []);

  return { data, loading, error };
}
